import * as constant from './constant'
export const mutations = {
  // STOCK LIST
  [constant.WATCHLIST_STOCK](state, payload) {
    if (payload) {
      state.stockWatchlist.watchlist = [] // clear old data
      payload.assets.forEach(item => {
        state.stockWatchlist.watchlist.push({
          id: item.subject_id,
          name: item.subject_name,
          data_date: item.date,
          period: '1D',
          percent: item.change,
          price: item.price,
          type: item.subject_id.includes("-") ? 'indice' : 'stock'
        })
      });
      state.stockWatchlist.updatedAt = payload.updated_at
    }
  },
  // FUND LIST
  [constant.WATCHLIST_FUND](state, payload) {
    if (payload) {
      state.fundWatchlist.watchlist = [] // clear old data
      payload.assets.forEach(item => {
        state.fundWatchlist.watchlist.push({
          id: item.subject_id,
          name: item.subject_name,
          data_date: item.date,
          period: '1D',
          percent: item.change,
          price: item.price,
          is_in_trending: item.is_in_trending,
          is_terminated: item.is_terminated,
          operation_ready: item.operation_ready,
          performance_ready: item.performance_ready,
          type: 'fund'
        })
      });
      state.fundWatchlist.updatedAt = payload.updated_at
    }
  },
  // GOLD LIST
  [constant.WATCHLIST_GOLD](state, payload) {
    if (payload) {
      let assetName
      state.goldWatchlist.watchlist = [] // clear old data
      payload.assets.forEach(item => {
        const id = item.subject_id == 'gold-trader-ornaments' ? 'gold-trader-ornament' : item.subject_id
        assetName = id.split("-")
        state.goldWatchlist.watchlist.push({
          id: id,
          name: assetName[assetName.length - 1],
          data_date: item.date,
          buy: item.buy,
          sell: item.sell,
          change: item.change,
          time: item.time,
          type: 'gold'
        })
      });
      state.goldWatchlist.updatedAt = payload.updated_at
    }
  },
}